<div class="vertical-filters" [ngClass]="{ collapsed: !isFiltersMenuOpen }">
    <div class="vertical-filters-header">
        <img src="assets/images/common/filter.svg" (click)="onToggleClick()" alt="filter" />
        <div>Filters</div>
        <img src="assets/images/arrows/chevron.svg" class="vertical-filters-header-img" (click)="onToggleClick()" alt="toggle" />
    </div>
    <div class="vertical-filters-options">
        <div class="vertical-filters-options-container">
            <div *ngFor="let optionGroup of optionsInsideCategories$ | async; let i = index">
                <div *ngIf="optionGroup.displayName && !optionGroup.isDynamic">
                    <app-accordion
                        [inMultiSelect]="true"
                        [expanded]="expandedCategories[optionGroup.displayName]"
                        [accordionTitle]="optionGroup.displayName | beautifyDisplayString"
                        (accordionExpansionEvent)="expandClicked(optionGroup.displayName, $event)"
                        [isNewFeature]="optionGroup.isNew === true">
                        <div
                            *ngFor="let option of optionGroup.options"
                            class="vertical-filters-option"
                            [ngClass]="{
                                'vertical-filters-option-selected': selectedIds.has(option.id) && !option.disabled,
                                'vertical-filters-option-disabled': option.disabled,
                            }"
                            (click)="onSelect(option.id)">
                            <mat-checkbox
                                color="primary"
                                [checked]="selectedIds.has(option.id)"
                                (click)="$event.stopPropagation()"
                                (change)="onSelect(option.id)">
                            </mat-checkbox>
                            <img *ngIf="option.iconPath" [src]="option.iconPath" class="option-img" />
                            <div *ngIf="!option.disabled" class="vertical-filters-option-text" appLongTextTooltip>
                                {{ option.withoutBeautifyDisplayName ? option.displayName : (option.displayName | beautifyDisplayString) }}
                            </div>
                        </div>
                    </app-accordion>
                </div>
            </div>
            <div>
                <app-accordion [inMultiSelect]="true" accordionTitle="Environment name">
                    <app-autocomplete-api [searchValuesCtrl]="searchEnvironmentNameValuesCtrl"
                        [pageFilters]="pageFilters" [filteredValues]="filteredEnvironmentNameValues"
                        [isLoading$]="isEnvironmentNameLoading$" [filterType]="environmentNameFilterEnum"
                        (optionOnSelection)="environmentNameSubmitted($event)">
                    </app-autocomplete-api>
                </app-accordion>
                <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Actor">
                    <app-autocomplete-api
                        [searchValuesCtrl]="searchActorValuesCtrl"
                        [pageFilters]="pageFilters"
                        [filteredValues]="filteredActorValues"
                        [isLoading$]="isActorLoading$"
                        [filterType]="actorFilterEnum"
                        (optionOnSelection)="actorSubmitted($event)">
                    </app-autocomplete-api>
                </app-accordion>
                <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Thread Id">
                    <app-autocomplete-api
                        [searchValuesCtrl]="searchThreadIdValuesCtrl"
                        [pageFilters]="pageFilters"
                        [filteredValues]="filteredThreadIdValues"
                        [isLoading$]="isThreadIdLoading$"
                        [filterType]="threadIdFilterEnum"
                        (optionOnSelection)="threadIdSubmitted($event)">
                    </app-autocomplete-api>
                </app-accordion>
                <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Agent">
                    <app-autocomplete-api
                        [searchValuesCtrl]="searchAgentValuesCtrl"
                        [pageFilters]="pageFilters"
                        [filteredValues]="filteredAgentValues"
                        [isLoading$]="isAgentLoading$"
                        [filterType]="agentNameFilterEnum"
                        (optionOnSelection)="agentSubmitted($event)">
                    </app-autocomplete-api>
                </app-accordion>
            </div>
        </div>
    </div>
</div>
<div [ngClass]="{ collapsed: isFiltersMenuOpen }">
    <img src="assets/images/arrows/filters-menu-closed.svg" (click)="onToggleClick()" class="collapsed-img" alt="collapse" />
</div>
